import { useState } from "react";

const LOCAL_STORAGE_KEY =
  "fjarrkontrollen.user-preferences.hiddenHeatingTechnologies";

function loadStoredState(): string[] {
  let storedValue = localStorage.getItem(LOCAL_STORAGE_KEY);
  if (storedValue !== null) {
    try {
      return JSON.parse(storedValue as string) as string[];
    } catch {
      return [];
    }
  } else {
    return [];
  }
}

function useHeatingTechnologySelection() {
  const [hiddenHeatingTechnologies, setHiddenHeatingTechnologies] =
    useState<string[]>(loadStoredState());

  const isHidden = (sectionId: string) =>
    hiddenHeatingTechnologies.includes(sectionId);

  const switchVisibilitySetting = (sectionId: string) => {
    let updatedHiddenTechnologiesList = hiddenHeatingTechnologies;
    if (isHidden(sectionId)) {
      updatedHiddenTechnologiesList = hiddenHeatingTechnologies.filter(
        (section) => section !== sectionId
      );
    } else {
      updatedHiddenTechnologiesList = [...hiddenHeatingTechnologies, sectionId];
    }

    setHiddenHeatingTechnologies(updatedHiddenTechnologiesList);

    localStorage.setItem(
      LOCAL_STORAGE_KEY,
      JSON.stringify(updatedHiddenTechnologiesList)
    );
  };

  return { hiddenHeatingTechnologies, isHidden, switchVisibilitySetting };
}

export default useHeatingTechnologySelection;
